import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ConfirmDialog from 'components/Dialog/Confirm';
import WorkingModal from './WorkingModal';
import {
  tryUpdatePositionName,
  tryAddPosition,
  tryDeletePosition,
  tryUpdatePositionType,
  fetchPositionList,
} from 'actions/UserActions.js';
import {getURL} from '../../routes';

class PositionPanel extends Component {
  state = {
    mode: 'OFF',
    selectedID: 0,
    typeChanging: false,
  }
  componentDidMount() {
    let {dispatch} = this.props;

    dispatch(fetchPositionList());
  }

  dismiss = () => {
    this.setState({mode: 'OFF'})
  }

  activeAdd = () => {
    this.setState({mode: 'ADD', selectedID: 0})
  }

  activeEdit = (id) => {
    return () => this.setState({mode: 'EDIT', selectedID: id})
  }

  handleDelete = (id, name) => {
    return () => {
      ConfirmDialog(`確認是否删除${name}`)
        .then(
          () => {
            this.props.dispatch(tryDeletePosition(id))
          },
          () => {}
        )
    }
  }

  handleAdd = (name) => {
    this.props.dispatch(tryAddPosition(name));
    this.dismiss();
  }

  handleTypeChange = (id, toType) => {
    this.setState({
      typeChanging: true
    });
    this.props.dispatch(tryUpdatePositionType(id, toType)).then(() => {
      this.setState({
        typeChanging: false
      });
    });
  }

  handleEdit = (id) => {
    return (name) => {
      this.props.dispatch(tryUpdatePositionName(id, name))
      this.dismiss();
    }
  }

  buildPositionRow = (positions) => {
    return positions.map((position) => {
      let id = position.get('id');
      let name = position.get('name');
      let type = position.get('type');

      return (
        <tr key={id + name + type}>
          <th>
            {name}
          </th>
          <th>
            <button
              className="btn btn-default"
              onClick={this.activeEdit(id)}>
              <span className="glyphicon glyphicon-pencil"/>
            </button>
            {" "}
            <button
              className="btn btn-danger"
              onClick={this.handleDelete(id, name)}>
              <span className="glyphicon glyphicon-trash" />
            </button>
          </th>
          <th>
            <input
              type="checkbox"
              checked={type == 1}
              onClick={() => this.handleTypeChange(id, type == 0 ? 1 : 0)}
              disabled={this.state.typeChanging} />
          </th>
        </tr>
      )
    })
  }

  render() {
    let {positions, dispatch} = this.props;
    let {mode, selectedID} = this.state;
    return (
      <div className="company setting-panel">
        <div className="setting-header">
          <button
            className="btn btn-default"
            onClick={()=>{dispatch(push(getURL('/ws-admin/setting')))}}>
            返回
          </button>
          <button
            className="btn btn-primary pull-right"
            onClick={this.activeAdd}>
            新增
          </button>
        </div>
        <div className="setting-content">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="name">
                  名稱
                </th>
                <th>
                  動作
                </th>
                <th>
                  屬於工序
                </th>
              </tr>
            </thead>
            <tbody>
              {positions.size > 0 && this.buildPositionRow(positions)}
            </tbody>
          </table>
        </div>
        {(mode === 'ADD' || mode === 'EDIT') &&
          <WorkingModal
            action={(selectedID > 0? this.handleEdit(selectedID) : this.handleAdd)}
            dismiss={this.dismiss}
            mode={mode}
            id={selectedID}
            name={(selectedID > 0 ? positions.get(positions.findIndex((type) => type.get('id') === selectedID)).get('name') : "")}
            />}
      </div>
    )
  }
}

export default connect((state) => ({
  positions: state.user.get('positionList')
}))(PositionPanel);



// WEBPACK FOOTER //
// ./src/components/Setting/PositionPanel.js